import { render, staticRenderFns } from "./company-brand-image-card.vue?vue&type=template&id=2756cb4d"
import script from "./company-brand-image-card.vue?vue&type=script&lang=js"
export * from "./company-brand-image-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports